export function WebSecurityPdf() {
    const val1 = "https://www.w3schools.com/html/html_quiz.asp";
  
    return (
      <>
        <h1 className="html_qns_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 8</strong> recommended Geeks for Geeks links that you can refer with important Topics
        </h1>
  
        <h4 className="des_qns_html">
          <ul>
            <li>1. Dive Into The <strong>Main</strong> Page</li>
            <li>2. Start with Quizz</li>
            <li>3. Test Your knowledge what you have, attempt to better Clarification</li>
          </ul>
        </h4>
  
        {/* <-----------------------------------------1------------------------------------------*/}
  
        <div className="html_links_container">
          <p className="vid" style={{ marginTop: '50px' }}>
            **** Practice For HTML (WebSecurity) ***
            <button
              style={{
                marginLeft: '200px',
                padding: '10px',
                background: 'black',
                color: 'white',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
              onClick={() => window.open(val1, "_blank")}
              aria-label="Go to WebSecurity quiz"
            >
              Click Me
            </button>
          </p>
        </div>
      </>
    );
  }
  
  export default WebSecurityPdf;
  